const YOUTUBE_API_KEY = process.env.YOUTUBE_API_KEY
const DGENIUS_CHANNEL_ID = process.env.DGENIUS_CHANNEL_ID

export {YOUTUBE_API_KEY, DGENIUS_CHANNEL_ID}